var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.conversa
    ? _c("section", { staticClass: "separable" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _vm._v(_vm._s(_vm.conversa.assunto))
                    ]),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      _vm._l(_vm.conversa.mensagemList, function(
                        mensagem,
                        index
                      ) {
                        return _c(
                          "app-collapse",
                          {
                            key: mensagem.id,
                            attrs: {
                              title:
                                mensagem.nomeRemetente +
                                " - " +
                                mensagem.dataEnviadaFormatada,
                              collapsed:
                                index < _vm.conversa.mensagemList.length - 1
                                  ? "1"
                                  : "0"
                            }
                          },
                          [
                            _c("p", {
                              domProps: { innerHTML: _vm._s(mensagem.conteudo) }
                            }),
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: mensagem.anexoList,
                                      stripe: "stripe"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "empty" },
                                        slot: "empty"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v("Não há anexos disponíveis.")
                                        ])
                                      ]
                                    ),
                                    _c("el-table-column", {
                                      staticClass: "td-column-anexo",
                                      attrs: { prop: "nome" }
                                    }),
                                    _c("el-table-column", {
                                      staticClass: "td-column-anexo",
                                      attrs: { align: "center", width: "85" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(scope) {
                                              return [
                                                _c("app-action-button", {
                                                  attrs: {
                                                    icone: "download",
                                                    nome: "file_download",
                                                    hoverColor: "#009f61",
                                                    text: "Baixar anexo"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.baixarAnexo(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f154e7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f154e7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppVisualizarConversa.vue
// module id = null
// module chunks = 